import { forwardRef } from 'react';
import {
  Card as SharedCard,
  FormField as SharedFormField,
  type CardProps as SharedCardProps,
  type FormFieldProps as SharedFormFieldProps,
} from 'pi-kiosk-shared/ui';

/** Local admin Button (D8 sizes / loading / icon-only a11y). See BUTTON_SIZE_NOTE.md. */
export { Button, type ButtonProps, type ButtonSize, type ButtonIntent } from './Button.js';

export type CardProps = Omit<SharedCardProps, 'surface'>;
export const Card = forwardRef<HTMLDivElement, CardProps>((props, ref) => (
  <SharedCard ref={ref} surface="admin" {...props} />
));
Card.displayName = 'Card';

export type FormFieldProps = SharedFormFieldProps;
export const FormField = SharedFormField;
